import { useEffect, useState } from "react";

export function DateTimeInput({ date, setDate }) {
	const [isSelected, setIsSelected] = useState(false);

	const handleDateTimeChange = (event) => {
		setDate(event.target.value);
		setIsSelected(true);
	};

	useEffect(() => {
		if (date !== undefined && date !== "") {
			setIsSelected(true);
		} else {
			setIsSelected(false);
		}
	}, [date]);

	let formattedDate = "";

	if (date) {
		formattedDate = date.split("T")[0];
	}

	return (
		<div>
			<input
				type="date"
				id={"datetime-"}
				name="datetime"
				value={formattedDate} // Exclude milliseconds
				onChange={handleDateTimeChange}
				style={{
					width: "90%",
					height: "30px",
					borderRadius: "3px",
					border: "1px solid #80808080",
					color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
					fontFamily:
						"'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif",
				}}
			/>
		</div>
	);
}